module.exports = __webpack_public_path__ + "static/media/tumblr.a88daf1b.svg";